/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'
import theme from 'styles/theme'
import { Box } from 'rebass'
import {
  display,
  position,
  width,
  textAlign,
  left,
  opacity,
} from 'styled-system'
import { fill } from 'styles/sharedStyle'

export const Wrapper = styled.ol`
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;

  > li {
    display: block;
    margin-bottom: ${theme.space[4]};
    width: 100%;
  }

  a {
    margin-right: 10px;
  }

  a:hover {
    cursor: pointer;
  }

  p {
    vertical-align: middle;
    margin: 0;
  }

  #brand-list--link {
    text-decoration: underline;
    color: ${theme.colors.sagemedium};
  }

  ${theme.mediaQueries.small} {
    > li {
      padding-right: ${theme.space[4]};
      width: 50%;
    }
  }

  ${theme.mediaQueries.medium} {
    > li {
      width: 25%;
    }
  }
`

export const ServicesWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: ${theme.space[1]};
`

export const Logo = styled(Box)`
  ${display}
  ${position}
  ${width}
  ${textAlign}
  ${left}
  ${opacity}
  * {
    ${fill};
  }
`
